import {
  NestingModeSchema,
  NestingModeType,
  PartTypeType,
  PricingModeSchema,
  PricingModeType,
} from "../types";
import { isBarOrProfile } from "./isBarOrProfile";
import { isSheetPartType } from "./isSheetPartType";

export const getDefaultUseNesting = ({
  partType,
  nestingMode,
  pricingMode,
}: {
  partType: PartTypeType | null;
  nestingMode: NestingModeType;
  pricingMode: PricingModeType;
}): boolean => {
  if (!partType) {
    return false;
  }

  if (pricingMode !== PricingModeSchema.enum.RAW) {
    return false;
  }

  switch (nestingMode) {
    case NestingModeSchema.enum.NEVER:
      return false;
    case NestingModeSchema.enum.AUTOMATIC:
      return isSheetPartType(partType) || isBarOrProfile(partType);
    case NestingModeSchema.enum.ALWAYS:
      return true;
  }
};
